var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:_vm.containerClass,style:(_vm.containerStyle)},[(_vm.column.children && _vm.column.children.footer)?_c('TTColumnSlot',{attrs:{"column":_vm.col}}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.columnProp('footer'))+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }